import styled from '@emotion/styled'

const LibStyledGrid = styled.ul`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
    gap: 3rem;
`
const LibStyledGridCell = styled.li`
    display: flex;
    flex-direction: column;
    align-items: center;

    // Force hardware acceleration to prevent flickering:
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
`

export { LibStyledGrid, LibStyledGridCell }
